export const EMPTY_JSON_SPEC = `{
  "root": "html",
  "elements": {
    "html": {
      "type": "Html",
      "props": { "lang": "en" },
      "children": ["head", "body"]
    },
    "head": {
      "type": "Head",
      "props": {},
      "children": []
    },
    "body": {
      "type": "Body",
      "props": {
        "style": {
          "margin": "0",
          "padding": "0",
          "backgroundColor": "#f4f6f8",
          "fontFamily": "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        }
      },
      "children": ["preview", "container"]
    },
    "preview": {
      "type": "Preview",
      "props": {
        "text": {
          "$template": "Invoice \${/invoiceNumber} from \${/companyName} is ready"
        }
      },
      "children": []
    },
    "container": {
      "type": "Container",
      "props": {
        "style": {
          "maxWidth": "640px",
          "margin": "0 auto",
          "padding": "32px 16px"
        }
      },
      "children": ["card"]
    },
    "card": {
      "type": "Section",
      "props": {
        "style": {
          "backgroundColor": "#ffffff",
          "border": "1px solid #e5e7eb",
          "borderRadius": "12px",
          "overflow": "hidden"
        }
      },
      "children": ["header", "content", "footer"]
    },
    "header": {
      "type": "Section",
      "props": {
        "style": {
          "backgroundColor": "#0f172a",
          "padding": "28px 32px"
        }
      },
      "children": ["company-name", "title", "subtitle"]
    },
    "company-name": {
      "type": "Text",
      "props": {
        "text": { "$state": "/companyName" },
        "style": {
          "margin": "0 0 10px",
          "color": "#93c5fd",
          "fontSize": "13px",
          "fontWeight": "700",
          "letterSpacing": "0.08em",
          "textTransform": "uppercase"
        }
      },
      "children": []
    },
    "title": {
      "type": "Heading",
      "props": {
        "as": "h1",
        "text": {
          "$template": "Invoice \${/invoiceNumber}"
        },
        "style": {
          "margin": "0",
          "color": "#ffffff",
          "fontSize": "28px",
          "lineHeight": "1.25"
        }
      },
      "children": []
    },
    "subtitle": {
      "type": "Text",
      "props": {
        "text": {
          "$template": "Due \${/dueDate} · \${/amountDue}"
        },
        "style": {
          "margin": "8px 0 0",
          "color": "#cbd5e1",
          "fontSize": "15px"
        }
      },
      "children": []
    },
    "content": {
      "type": "Section",
      "props": {
        "style": { "padding": "32px" }
      },
      "children": ["greeting", "summary-box", "line-items", "pay-button", "past-due-warning"]
    },
    "greeting": {
      "type": "Text",
      "props": {
        "text": {
          "$template": "Hi \${/customerName}, your invoice is ready for review."
        },
        "style": {
          "margin": "0 0 24px",
          "color": "#111827",
          "fontSize": "16px",
          "lineHeight": "1.6"
        }
      },
      "children": []
    },
    "summary-box": {
      "type": "Section",
      "props": {
        "style": {
          "backgroundColor": "#f8fafc",
          "border": "1px solid #e2e8f0",
          "borderRadius": "10px",
          "padding": "18px",
          "marginBottom": "24px"
        }
      },
      "children": ["summary-row-one", "summary-row-two"]
    },
    "summary-row-one": {
      "type": "Row",
      "props": {},
      "children": ["summary-invoice", "summary-amount"]
    },
    "summary-row-two": {
      "type": "Row",
      "props": {},
      "children": ["summary-issued", "summary-due"]
    },
    "summary-invoice": {
      "type": "Column",
      "props": { "style": { "padding": "6px 8px" } },
      "children": ["summary-invoice-text"]
    },
    "summary-amount": {
      "type": "Column",
      "props": { "style": { "padding": "6px 8px" } },
      "children": ["summary-amount-text"]
    },
    "summary-issued": {
      "type": "Column",
      "props": { "style": { "padding": "6px 8px" } },
      "children": ["summary-issued-text"]
    },
    "summary-due": {
      "type": "Column",
      "props": { "style": { "padding": "6px 8px" } },
      "children": ["summary-due-text"]
    },
    "summary-invoice-text": {
      "type": "Text",
      "props": {
        "text": { "$template": "Invoice: \${/invoiceNumber}" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#334155" }
      },
      "children": []
    },
    "summary-amount-text": {
      "type": "Text",
      "props": {
        "text": { "$template": "Amount: \${/amountDue}" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#334155" }
      },
      "children": []
    },
    "summary-issued-text": {
      "type": "Text",
      "props": {
        "text": { "$template": "Issued: \${/issuedDate}" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#334155" }
      },
      "children": []
    },
    "summary-due-text": {
      "type": "Text",
      "props": {
        "text": { "$template": "Due: \${/dueDate}" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#334155" }
      },
      "children": []
    },
    "line-items": {
      "type": "Section",
      "props": {
        "style": {
          "borderTop": "1px solid #e5e7eb",
          "borderBottom": "1px solid #e5e7eb",
          "marginBottom": "24px"
        }
      },
      "children": ["line-item-row"],
      "repeat": { "statePath": "/lineItems", "key": "sku" }
    },
    "line-item-row": {
      "type": "Row",
      "props": {
        "style": { "borderBottom": "1px solid #f1f5f9" }
      },
      "children": ["item-name-column", "item-qty-column", "item-total-column"]
    },
    "item-name-column": {
      "type": "Column",
      "props": { "style": { "padding": "12px 8px", "width": "55%" } },
      "children": ["item-name-text"]
    },
    "item-qty-column": {
      "type": "Column",
      "props": { "style": { "padding": "12px 8px", "width": "20%" } },
      "children": ["item-qty-text"]
    },
    "item-total-column": {
      "type": "Column",
      "props": { "style": { "padding": "12px 8px", "width": "25%" } },
      "children": ["item-total-text"]
    },
    "item-name-text": {
      "type": "Text",
      "props": {
        "text": { "$item": "description" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#111827" }
      },
      "children": []
    },
    "item-qty-text": {
      "type": "Text",
      "props": {
        "text": { "$template": "Qty: \${quantity}" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#64748b" }
      },
      "children": []
    },
    "item-total-text": {
      "type": "Text",
      "props": {
        "text": { "$item": "total" },
        "style": { "margin": "0", "fontSize": "14px", "color": "#111827", "fontWeight": "700", "textAlign": "right" }
      },
      "children": []
    },
    "pay-button": {
      "type": "Button",
      "props": {
        "href": { "$state": "/paymentUrl" },
        "text": "Review and pay invoice",
        "style": {
          "display": "inline-block",
          "backgroundColor": "#2563eb",
          "borderRadius": "8px",
          "color": "#ffffff",
          "fontSize": "15px",
          "fontWeight": "700",
          "padding": "12px 18px",
          "textDecoration": "none"
        }
      },
      "children": []
    },
    "past-due-warning": {
      "type": "Text",
      "visible": [{ "$state": "/isPastDue" }],
      "props": {
        "text": "This invoice is past due. Please contact billing if payment has already been sent.",
        "style": {
          "margin": "20px 0 0",
          "backgroundColor": "#fef2f2",
          "border": "1px solid #fecaca",
          "borderRadius": "8px",
          "color": "#991b1b",
          "fontSize": "14px",
          "lineHeight": "1.5",
          "padding": "12px"
        }
      },
      "children": []
    },
    "footer": {
      "type": "Section",
      "props": {
        "style": {
          "borderTop": "1px solid #e5e7eb",
          "padding": "20px 32px",
          "backgroundColor": "#f8fafc"
        }
      },
      "children": ["footer-text"]
    },
    "footer-text": {
      "type": "Text",
      "props": {
        "text": {
          "$template": "Questions? Reply to this email or contact \${/billingEmail}."
        },
        "style": {
          "margin": "0",
          "color": "#64748b",
          "fontSize": "13px",
          "lineHeight": "1.5"
        }
      },
      "children": []
    }
  }
}`;

export type JsonRecordParseResult =
  | { data: Record<string, unknown>; error?: never }
  | { data?: never; error: string };

export function isJsonRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function parseJsonRecord(value: string): JsonRecordParseResult {
  try {
    const parsed: unknown = JSON.parse(value);
    if (!isJsonRecord(parsed)) {
      return { error: 'JSON must be an object.' };
    }
    return { data: parsed };
  } catch (error) {
    return {
      error: error instanceof Error ? error.message : 'Invalid JSON.',
    };
  }
}

export function validateEmailSpecShape(
  spec: Record<string, unknown>,
): string | null {
  if (typeof spec.root !== 'string' || !spec.root.trim()) {
    return 'Template blocks spec root must be a non-empty string.';
  }

  if (!isJsonRecord(spec.elements)) {
    return 'Template blocks spec elements must be an object.';
  }

  if (!isJsonRecord(spec.elements[spec.root])) {
    return `Template blocks spec root element "${spec.root}" must exist in elements.`;
  }

  for (const [key, element] of Object.entries(spec.elements)) {
    if (!isJsonRecord(element)) {
      return `Element "${key}" must be an object.`;
    }
    if (typeof element.type !== 'string' || !element.type.trim()) {
      return `Element "${key}" must define a type.`;
    }
    if (element.props !== undefined && !isJsonRecord(element.props)) {
      return `Element "${key}" props must be an object.`;
    }
    if (
      element.children !== undefined &&
      (!Array.isArray(element.children) ||
        !element.children.every((child) => typeof child === 'string'))
    ) {
      return `Element "${key}" children must be an array of element keys.`;
    }
    if (Array.isArray(element.children)) {
      for (const childKey of element.children) {
        if (!isJsonRecord(spec.elements[childKey])) {
          return `Element "${key}" references missing child "${childKey}".`;
        }
      }
    }
  }

  return null;
}

export function parseEmailSpec(value: string): JsonRecordParseResult {
  const parseResult = parseJsonRecord(value);
  if (parseResult.error || !parseResult.data) {
    return parseResult;
  }

  const shapeError = validateEmailSpecShape(parseResult.data);
  if (shapeError) {
    return { error: shapeError };
  }

  return parseResult;
}

export function stringifyJsonSpec(
  jsonSpec: Record<string, unknown> | null | undefined,
): string {
  return jsonSpec ? JSON.stringify(jsonSpec, null, 2) : EMPTY_JSON_SPEC;
}
